import React, { HTMLAttributes, FC } from 'react'
import cn from 'classnames'

export const SearchBarCell: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className }) => {
  return (
    <div className={cn('lg:border-neutral-very-light flex lg:border-e-2 lg:last:border-none', className)}>
      {children}
    </div>
  )
}
